// i18n file for product compliance module
export const productComplianceI18n = {
  de: {
    productComplianceLogo: "AI",
    productComplianceTimeline: "Timeline",
    productComplianceSdsHubTitle: "SDS-Compliance-Hub",
    productComplianceSdsHubSubtitle:
      "KI-unterstützte Entscheidungen, nachvollziehbar und exportierbar",
    sdsNavOverview: "Übersicht",
    sdsNavSuppliers: "Lieferanten",
    sdsNavProducts: "Produkte",
    sdsNavActions: "Aktionen",
    sdsNavComparison: "Gegenüberstellung",
    sdsNavNewComparison: "Neue Gegenüberstellung",
    productComplianceLatency: "Latenz 230ms",
    productComplianceAuditStreamingOn: "Audit-Streaming aktiv",
    productComplianceTabDashboard: "Rollenbasiertes Dashboard",
    productComplianceTabWorkspaceDiff: "Workspace Smart Diff",
    productComplianceTabTimelineEvidence: "Timeline + Evidence Pack",
    productComplianceTabSitesVariables: "Standorte & Variablen",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Admin",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "Ausstehende Prüfung",
    productComplianceDashboardSummaryPendingDescription:
      "Dokumente warten auf Validierung",
    productComplianceDashboardSummaryOverdue: "Überfällige Aufgaben",
    productComplianceDashboardSummaryOverdueDescription:
      "Zugewiesene Aktionen außerhalb SLA",
    productComplianceDashboardSummaryReviewTime: "Ø Prüfzeit",
    productComplianceDashboardSummaryReviewTimeDescription:
      "Über letzte 30 Tage",
    productComplianceDashboardSummaryPrioritization: "Priorisierung",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Automatisch voranalysierte Abschnitte",
    productComplianceDashboardLibraryTitle: "Materialbibliothek",
    productComplianceDashboardLibrarySubtitle:
      "Suche, Risiko und direkter Zugriff auf den Workspace",
    productComplianceDashboardUploadDrop: "SDS-Datei hier ablegen oder",
    productComplianceDashboardUploadBrowse: "zum Durchsuchen klicken",
    productComplianceDashboardSearchPlaceholder:
      "Nach Material oder CAS suchen...",
    productComplianceDashboardColumnMaterial: "Material",
    productComplianceDashboardColumnWorkflow: "Workflow",
    productComplianceDashboardColumnRiskScore: "Risikoscore",
    productComplianceDashboardOpenWorkspace: "Workspace öffnen",
    productComplianceDashboardWorkspaceNotificationTitle: "Workspace",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Workspace öffnen: {name}",
    productComplianceDashboardUploadComment:
      "SDS-Upload aus Product-Compliance-Dashboard",
    productComplianceDashboardUploadSingleFileWarning:
      "Nur eine Datei gleichzeitig erlaubt ({fileName}).",
    sdsProductListKpiAwaitingReview: "Ausstehende Prüfung",
    sdsProductListKpiInProgress: "In Bearbeitung",
    sdsProductListKpiParsingIncomplete: "Parsing unvollständig",
    sdsProductListFilterAll: "Alle",
    sdsProductListFilterPendingReview: "Ausstehend",
    sdsProductListFilterInProgress: "In Bearbeitung",
    sdsProductListFilterApproved: "Freigegeben",
    sdsProductListFilterObsolete: "Veraltet",
    sdsProductListImportSds: "SDS importieren",
    sdsProductListReviewSds: "SDS prüfen",
    sdsProductAddButton: "Produkt anlegen",
    sdsProductFieldTradeName: "Handelsname",
    sdsProductFieldInternalCode: "Interner Code",
    sdsProductFieldCas: "CAS-Nummer",
    sdsProductFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsProductFieldUfi: "UFI",
    sdsProductFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsProductFieldDescription: "Beschreibung",
    sdsProductFieldPrimarySupplier: "Primärer Lieferant",
    sdsFeatureRequiresBackend:
      "Diese Funktion benötigt ein Backend-Update und ist aktuell deaktiviert.",
    sdsValidationRequired: "Pflichtfeld",
    sdsProductListColumnProduct: "Produkt",
    sdsProductListColumnSupplier: "Lieferant",
    sdsProductListColumnSdsStatus: "SDS-Status",
    sdsProductListColumnSections: "Abschnitte",
    sdsProductListColumnLastUpdated: "Zuletzt aktualisiert",
    sdsOverviewTitle: "Compliance Übersicht",
    sdsOverviewAwaitingReview: "Ausstehende Prüfung",
    sdsOverviewAwaitingReviewDesc: "Produkte warten auf Freigabe",
    sdsOverviewInProgress: "In Bearbeitung",
    sdsOverviewInProgressDesc: "Aktive Compliance-Prüfungen",
    sdsOverviewOverdue: "Überfällig",
    sdsOverviewOverdueDesc: "Produkte mit ausstehender Prüfung (>14 Tage)",
    sdsOverviewApprovedThisMonth: "Letzte 30 Tage freigegeben",
    sdsOverviewApprovedThisMonthDesc: "Freigegebene Produkte (letzte 30 Tage)",
    sdsOverviewPriorityQueue: "Produkte mit Priorität",
    sdsOverviewNothingPending: "Keine offenen Prüfungen.",
    sdsOverviewQuickActions: "Schnellaktionen",
    sdsOverviewExportActions: "Aktionsbericht exportieren",
    sdsOverviewDaysPending: "Tage offen",
    sdsOverviewComingSoon: "In Vorbereitung",
    sdsWorkspaceImportNewVersion: "Neue Version importieren",
    sdsWorkspaceViewHistory: "Verlauf anzeigen",
    sdsWorkspaceCurrentVersion: "Aktuelle Version",
    sdsWorkspaceSectionsDetected: "Erkannte Abschnitte",
    sdsWorkspaceMissingSections: "Fehlende Abschnitte",
    sdsApprovedSourcesTitle: "Freigegebene Quellen",
    sdsApprovedSourcesEmpty: "Keine freigegebenen Quellen verfügbar.",
    sdsWorkspaceCompareTitle: "Versionen vergleichen",
    sdsWorkspaceSelectBaseline: "Baseline auswählen",
    sdsWorkspaceSelectIncoming: "Eingehende Version auswählen",
    sdsWorkspaceSelectPlaceholder: "Version auswählen",
    sdsWorkspaceComparingPreview: "Vergleich: {baseline} vs. {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Aktuell wird nur die neueste Version angezeigt. Vollständiger Versionsverlauf ist nach einem Backend-Update verfügbar.",
    sdsWorkspaceStartComparison: "Vergleich starten",
    sdsWizardBadge: "Assistent",
    sdsWizardStep1Title: "Produkt wählen",
    sdsWizardStep2Title: "Versionen wählen",
    sdsWizardStep3Title: "Konfigurieren",
    sdsWizardSelectedProduct: "Ausgewähltes Produkt",
    sdsWizardVersionsStubNotice:
      "Nur eine Version ist für dieses Produkt verfügbar. Importieren Sie weitere Versionen oder warten Sie auf den Versionsverlauf-Endpunkt.",
    sdsWizardCrossSupplier: "Lieferantenübergreifender Vergleich",
    sdsWizardCrossSupplierDesc:
      "Wenn aktiviert, können Baseline und Incoming von unterschiedlichen Lieferanten stammen.",
    sdsWizardNoBaselineOptions: "Keine Baseline-Versionen verfügbar.",
    sdsWizardNoIncomingOptions: "Keine eingehenden Versionen verfügbar.",
    sdsWizardComparisonName: "Vergleichsname",
    sdsWizardComparisonNotes: "Notizen",
    sdsWizardBack: "Zurück",
    sdsWizardNext: "Weiter",
    sdsWizardStartComparison: "Vergleich starten",
    sdsComparisonToolbarViewSplit: "Geteilt",
    sdsComparisonToolbarViewUnified: "Vereinheitlicht",
    sdsComparisonToolbarShowChangesOnly: "Nur Änderungen anzeigen",
    sdsComparisonToolbarJumpSection: "Zu Abschnitt springen",
    sdsComparisonDevelopmentModeNotice:
      "Entwicklungsmodus: Mock-Vergleichsdaten werden angezeigt. Verbinden Sie /api/product-compliance/comparisons/:id, sobald verfügbar.",
    sdsReportExportComparison: "SDS-Vergleichsbericht exportieren",
    sdsReportBrand: "SMX Product Compliance",
    sdsReportTitle: "SDS-Vergleichsbericht",
    sdsReportGeneratedOn: "Erstellt am",
    sdsReportProduct: "Produkt",
    sdsReportBaseline: "Baseline",
    sdsReportIncoming: "Neue Version",
    sdsReportBy: "Erstellt von",
    sdsReportDate: "Vergleichsdatum",
    sdsReportExecutiveSummary: "Management-Zusammenfassung",
    sdsReportCriticalChanges: "Kritische Änderungen",
    sdsReportHighChanges: "Hohe Änderungen",
    sdsReportActionsAssigned: "Zugewiesene Aktionen",
    sdsReportSections: "Abschnitte",
    sdsReportSectionAnalysis: "Abschnittsanalyse",
    sdsReportNoNote: "Keine Compliance-Notiz vorhanden.",
    sdsReportUnchangedSections: "Unveränderte Abschnitte",
    sdsReportReviewedBy: "Geprüft von",
    sdsReportApprovedBy: "Freigegeben von",
    sdsReportSignature: "Unterschrift",
    sdsReportEvidenceVersionsTitle: "Alle SDS-Versionen",
    sdsReportEvidenceVersionLabel: "Versionsbezeichnung",
    sdsReportEvidenceRevisionDate: "Revisionsdatum",
    sdsReportEvidenceImportDate: "Importdatum",
    sdsReportEvidenceWorkflowStatus: "Workflow-Status",
    sdsReportEvidenceSectionsDetected: "Erkannte Abschnitte",
    sdsReportEvidenceComparisonsTitle: "Vergleichshistorie",
    sdsReportEvidenceNoComparisons: "Keine abgeschlossenen Vergleiche erfasst.",
    sdsReportEvidenceOpenActionsTitle: "Zusammenfassung offener Aktionen",
    sdsReportEvidenceActionCount: "Anzahl",
    sdsReportEvidenceNoOpenActions: "Keine offenen Aktionen vorhanden.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "Kein Inhalt vorhanden",
    sdsComparisonUnchangedHidden: "unveränderte Abschnitte ausgeblendet",
    sdsComparisonShowAllSections: "Alle anzeigen",
    sdsComparisonSectionCriticalChange: "Kritische Änderung",
    sdsComparisonSectionHighImpact: "Hohe Auswirkung",
    sdsComparisonSectionChanged: "Geändert",
    sdsComparisonSectionMinorChange: "Kleine Änderung",
    sdsComparisonSectionNoChange: "Keine Änderung",
    sdsNoteComplianceImpactLabel: "Compliance-Auswirkung",
    sdsNoteComplianceImpactPlaceholder:
      "Beschreiben Sie die Compliance-Auswirkung für diesen Abschnitt.",
    sdsNoteRequiredForCritical:
      "Bei kritischen/hohen Änderungen ist eine Notiz erforderlich.",
    sdsNoteChangeSeverityLabel: "Änderungsschwere",
    sdsNoteChangeSeverityNone: "Keine",
    sdsNoteChangeSeverityLow: "Niedrig",
    sdsNoteChangeSeverityMedium: "Mittel",
    sdsNoteChangeSeverityHigh: "Hoch",
    sdsNoteChangeSeverityCritical: "Kritisch",
    sdsNoteAssignedActions: "Zugewiesene Aktionen",
    sdsNoteAddAction: "Aktion hinzufügen",
    sdsNoteDepartmentLabel: "Abteilung",
    sdsNoteActionTypeLabel: "Aktionstyp",
    sdsNoteActionTypeOther: "Andere",
    sdsNoteDueDateLabel: "Fällig am",
    sdsDeptPlantSafety: "Anlagensicherheit",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Einkauf",
    sdsDeptQuality: "Qualität",
    sdsDeptLogistics: "Logistik",
    sdsDeptWarehouse: "Lager",
    sdsActionUpdateSops: "SOPs aktualisieren",
    sdsActionUpdateEmergencyProcedures: "Notfallverfahren aktualisieren",
    sdsActionUpdateWorkplaceSignage: "Arbeitsplatzkennzeichnung aktualisieren",
    sdsActionScheduleTraining: "Schulung planen",
    sdsActionUpdateRiskAssessment: "Risikobewertung aktualisieren",
    sdsActionReportToAuthority: "An Behörde melden",
    sdsActionVendorQuery: "Rückfrage an Lieferanten",
    sdsActionSupplierQualification: "Lieferantenqualifizierung",
    sdsActionSourceAlternative: "Alternative Quelle suchen",
    sdsActionUpdateSpecification: "Spezifikation aktualisieren",
    sdsActionUpdateProductDataSheet: "Produktdatenblatt aktualisieren",
    sdsActionUpdateTransportDoc: "Transportdokument aktualisieren",
    sdsActionUpdateHazmatDeclaration: "Gefahrguterklärung aktualisieren",
    sdsActionUpdateStorageSop: "Lager-SOP aktualisieren",
    sdsActionReviewSegregation: "Separationskonzept prüfen",
    sdsActionsTitle: "Aktionsverfolgung",
    sdsActionsFilterStatus: "Status",
    sdsActionsFilterDepartment: "Abteilung",
    sdsActionsFilterProduct: "Produkt oder CAS suchen",
    sdsActionsFilterDueDateFrom: "Fällig von",
    sdsActionsFilterDueDateTo: "Fällig bis",
    sdsActionsColumnProduct: "Produkt",
    sdsActionsColumnSection: "Abschnitt",
    sdsActionsColumnDepartment: "Abteilung",
    sdsActionsColumnAction: "Aktion",
    sdsActionsColumnDueDate: "Fälligkeit",
    sdsActionsColumnStatus: "Status",
    sdsActionsMarkComplete: "Abschließen",
    sdsActionsMarkCompleteConfirm:
      "Möchten Sie diese Aktion als abgeschlossen markieren?",
    sdsActionsMarkedComplete: "Aktion als abgeschlossen markiert",
    sdsActionsStatusOpen: "Offen",
    sdsActionsStatusInProgress: "In Bearbeitung",
    sdsActionsStatusCompleted: "Abgeschlossen",
    sdsActionsStatusOverdue: "Überfällig",
    sdsActionsSelected: "ausgewählt",
    sdsActionsEmptyState:
      "Noch keine Compliance-Aktionen vorhanden. Aktionen werden bei der Vergleichsprüfung erstellt.",
    sdsActionsBackendNotice:
      "Die Aktionsliste zeigt derzeit keine Backend-Daten. Inhalte erscheinen, sobald die API-Integration verfügbar ist.",
    sdsApproveReviewDecision: "Prüfung & Entscheidung",
    sdsApproveDocumentationProgress: "Dokumentationsfortschritt",
    sdsApproveBlockedMissingNotes: "Freigabe blockiert, fehlende Notizen",
    sdsApproveOpenActions: "Offene Aktionen",
    sdsApproveComparisonStarted: "Vergleich gestartet",
    sdsApproveBaseline: "Baseline",
    sdsApproveIncoming: "Incoming",
    sdsApproveButton: "Freigeben",
    sdsRejectButton: "Ablehnen",
    sdsApproveConfirmMessage:
      "Möchten Sie diesen Vergleich wirklich freigeben?",
    sdsApproveConfirmMessageDetailed:
      'Möchten Sie "{incoming}" als neue Baseline für "{product}" freigeben? Die bisherige Baseline ("{baseline}") wird als ersetzt archiviert.',
    sdsApproveConfirmTitle: "Vergleich freigeben",
    sdsApproveSuccess: "Vergleich erfolgreich freigegeben",
    sdsRejectReasonPrompt: "Bitte Ablehnungsgrund eingeben",
    sdsRejectTitle: "Vergleich ablehnen",
    sdsRejectSuccess: "Vergleich wurde abgelehnt",
    productComplianceWorkflowReceived: "Eingegangen",
    productComplianceWorkflowInProgress: "In Bearbeitung",
    productComplianceWorkflowApproved: "Freigegeben",
    productComplianceWorkflowObsolete: "Veraltet",
    productComplianceTimelineSummaryPending: "Ausstehende Prüfungen",
    productComplianceTimelineSummaryPendingDescription:
      "Versionen mit offener Freigabe",
    productComplianceTimelineSummaryApproved: "Freigegeben",
    productComplianceTimelineSummaryApprovedDescription:
      "Versionen mit validierter Konformität",
    productComplianceTimelineSummarySuperseded: "Ersetzt",
    productComplianceTimelineSummarySupersededDescription:
      "Versionen nur zur Rückverfolgung",
    productComplianceTimelineSectionTitle: "Vollständige Timeline",
    productComplianceTimelineSectionSubtitle:
      "Chronologische SDS-Versionen, Status, Importe und letzte Änderungen",
    productComplianceTimelineFamilySearchPlaceholder:
      "Nach CAS, Lieferant oder Produkt suchen...",
    productComplianceTimelineFamilyProduct: "Produkt",
    productComplianceTimelineFamilySupplier: "Lieferant",
    productComplianceTimelineFamilyVersions: "Versionen",
    productComplianceTimelineOrderAz: "A-Z",
    productComplianceTimelineOrderNewest: "Neueste zuerst",
    productComplianceTimelineOrderOldest: "Älteste zuerst",
    productComplianceTimelineSearchPlaceholder:
      "Version, Lieferant oder Änderung suchen...",
    productComplianceTimelineImported: "Import",
    productComplianceTimelineLatestChanges: "Letzte Änderungen",
    productComplianceTimelineEmpty:
      "Keine Timeline-Einträge für die aktuelle Suche.",
    productComplianceTimelineShortcutsTitle: "Schnellzugriffe",
    productComplianceTimelineShortcutGenealogy: "Rekursive Genealogie öffnen",
    productComplianceTimelineShortcutEvidence: "Evidence Pack erstellen",
    productComplianceTimelineShortcutLabel: "GHS-Etikett drucken",
    productComplianceTimelineLegendTitle: "Statuslegende",
    productComplianceTimelineCompositionTitle: "Zusammensetzung",
    productComplianceTimelineCharacteristicsTitle: "Produktmerkmale",
    productComplianceTimelineDocumentSignalsTitle: "Dokumentsignale",
    productComplianceTimelineFieldSupplier: "Lieferant",
    productComplianceTimelineFieldUfi: "UFI",
    productComplianceTimelineFieldSubstance: "Substanz",
    productComplianceTimelineFieldConcentration: "Konzentration",
    productComplianceTimelineFieldSection3Source: "Quelle Abschnitt 3",
    productComplianceTimelineFieldParsingStatus: "Parsing-Status",
    productComplianceTimelineFieldSectionsDetected: "Erkannte Abschnitte",
    productComplianceTimelineFieldMissingSections: "Fehlende Abschnitte",
    productComplianceTimelineFieldAcceptability: "Akzeptanzstatus",
    productComplianceTimelineFieldAdditional: "Weitere Angaben",
    productComplianceTimelineNotAvailable: "Nicht verfügbar",
    productComplianceTimelineAcceptabilityAccepted: "Akzeptiert",
    productComplianceTimelineAcceptabilityRejected: "Abgelehnt",
    productComplianceTimelineAcceptabilityPending: "Ausstehend",
    productComplianceTimelineSection3SourceHttp: "Extraktor API",
    productComplianceTimelineSection3SourceDeterministic:
      "Deterministische Analyse",
    productComplianceTimelineSection3SourceHttpDisabled:
      "Extraktor deaktiviert",
    productComplianceTimelineParsingComplete: "Vollständig",
    productComplianceTimelineParsingIncomplete: "Unvollständig",
    productComplianceStatusPendingReview: "Ausstehend",
    productComplianceStatusApproved: "Freigegeben",
    productComplianceStatusSuperseded: "Ersetzt",
    productComplianceMaterialSodiumHydroxide: "Natriumhydroxid 50%",
    productComplianceMaterialSulfuricAcid: "Schwefelsäure 98%",
    productComplianceSupplierChemcorp: "Lieferant: ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Lieferant: GlobalChem Ltd.",
    productComplianceTimelineChangeSodium20Section2:
      "Abschnitt 2: Aktualisierte Piktogramme für Korrosionsgefahr",
    productComplianceTimelineChangeSodium20Section16:
      "Abschnitt 16: CLP-Referenzen harmonisiert",
    productComplianceTimelineChangeSodium21Section8:
      "Abschnitt 8: Expositionsgrenzen für Standort Lyon angepasst",
    productComplianceTimelineChangeSodium21Section11:
      "Abschnitt 11: Toxikologietext präzisiert",
    productComplianceTimelineChangeSodium30Section8:
      "Abschnitt 8: Verstärkte PSA, Visier obligatorisch",
    productComplianceTimelineChangeSodium30Section2:
      "Abschnitt 2: Signalwort von Warning auf Danger geändert",
    productComplianceTimelineChangeSodium30Section15:
      "Abschnitt 15: Regulatorische Referenzen ergänzt",
    productComplianceTimelineChangeSodium12Section3:
      "Abschnitt 3: Nominale Konzentration 49-51%",
    productComplianceTimelineChangeSodium12Section8:
      "Abschnitt 8: Funktionale Gleichwertigkeit bestätigt",
    productComplianceTimelineChangeSodium12Section16:
      "Abschnitt 16: Transport-Addendum ergänzt",
    productComplianceTimelineChangeSulfuric15Section8:
      "Abschnitt 8: Zusätzlicher Handschutz bei Heißabfüllung",
    productComplianceTimelineChangeSulfuric15Section14:
      "Abschnitt 14: UN-Transportklassifizierung verfeinert",
    productComplianceTimelineDeleteVersion: "Version löschen",
    productComplianceTimelineDeleteFamily: "Familie löschen",
    productComplianceTimelineDeleteVersionConfirmTitle: "Version löschen",
    productComplianceTimelineDeleteVersionConfirmMessage:
      'Möchten Sie die Version "{version}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    productComplianceTimelineDeleteFamilyConfirmTitle:
      "Dokumentfamilie löschen",
    productComplianceTimelineDeleteFamilyConfirmMessage:
      "Möchten Sie diese Dokumentfamilie mit allen {count} Version(en) wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    productComplianceTimelineDeleteVersionSuccess:
      "Version erfolgreich gelöscht",
    productComplianceTimelineDeleteFamilySuccess:
      "Dokumentfamilie erfolgreich gelöscht ({count} Version(en))",
    productComplianceTimelineDeleteError: "Fehler beim Löschen",
    sdsTimelineBackToWorkspace: "Zurück zum Workspace",
    sdsTimelineExportEvidence: "Nachweisbericht exportieren",
    sdsTimelineViewComparison: "Vergleich ansehen",
    sdsImportDialogTitle: "SDS importieren",
    sdsImportStepValidating: "Datei prüfen...",
    sdsImportStepExtractingText: "Text extrahieren...",
    sdsImportStepParsingSections: "Abschnitte analysieren...",
    sdsImportStepExtractingIdentity: "Identität ermitteln...",
    sdsImportStepExtractingSubstances: "Substanzen extrahieren...",
    sdsImportStepResolvingSupplier: "Lieferant suchen...",
    sdsImportStepResolvingProduct: "Produkt suchen...",
    sdsImportStepComplete: "Extraktion abgeschlossen",
    sdsImportSectionDocument: "Dokument",
    sdsImportSectionProduct: "Produkt",
    sdsImportSectionSupplier: "Lieferant",
    sdsImportSectionSubstances: "Substanzen",
    sdsImportSectionComment: "Kommentar",
    sdsImportFieldFilename: "Datei",
    sdsImportFieldPages: "Seiten",
    sdsImportFieldLanguage: "Sprache",
    sdsImportFieldRevisionDate: "Revisionsdatum",
    sdsImportFieldProductName: "Produktname",
    sdsImportFieldTradeName: "Handelsname",
    sdsImportFieldUfi: "UFI",
    sdsImportFieldSupplierName: "Lieferantenname",
    sdsImportSupplierNotFound:
      "Lieferant im Register nicht gefunden. Sie können mit einem bestehenden Lieferanten verknüpfen oder neuen Eintrag übernehmen.",
    sdsImportProductNotFound:
      "Produkt im Katalog nicht gefunden. Sie können mit einem bestehenden Produkt verknüpfen oder neuen Eintrag übernehmen.",
    sdsImportLinkExistingSupplier: "Bestehenden Lieferanten verknüpfen",
    sdsImportLinkExistingProduct: "Bestehendes Produkt verknüpfen",
    sdsSupplierListTitle: "Lieferanten",
    sdsSupplierAddButton: "Lieferant hinzufügen",
    sdsSupplierEmptyState: "Keine Lieferanten verfügbar.",
    sdsSupplierBackendNotice:
      "Die Lieferantenverwaltung erfordert ein Backend-Update — die Liste erscheint, sobald sie verfügbar ist.",
    sdsSupplierContact: "Kontakt",
    sdsSupplierProductsCount: "Produkte",
    sdsSupplierSdsDocuments: "SDS-Dokumente",
    sdsSupplierSdsEmptyState: "Keine SDS-Dokumente verfügbar.",
    sdsSupplierFieldName: "Name",
    sdsSupplierFieldCode: "Code",
    sdsSupplierFieldCountry: "Land",
    sdsSupplierFieldAddress: "Adresse",
    sdsSupplierFieldContactName: "Kontaktname",
    sdsSupplierFieldContactEmail: "Kontakt-E-Mail",
    sdsSupplierFieldContact: "Kontakt",
    sdsSupplierFieldStatus: "Status",
    sdsSupplierFieldNotes: "Notizen",
    sdsSupplierCodePlaceholder: "Lieferantencode",
    sdsSupplierStatusActive: "Aktiv",
    sdsSupplierStatusInactive: "Inaktiv",
    sdsSupplierStatusUnderReview: "In Prüfung",
    sdsSupplierSavedSuccess: "Lieferant erfolgreich gespeichert.",
    sdsSupplierDetailTitle: "Lieferantendetails",
    sdsSupplierNotVerified: "Nicht verifiziert",
    sdsSupplierFormCrudNotice:
      "Anlegen und Bearbeiten von Lieferanten erfordert ein Backend-Update. Das Formular kann bereits ausgefüllt werden.",
    sdsImportFieldLongComment: "Notiz",
    sdsImportSubstanceName: "Name",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Konzentration",
    sdsImportSubstanceAdd: "Substanz hinzufügen",
    sdsImportButtonConfirm: "Import bestätigen",
    sdsImportStatusFound: "Gefunden",
    sdsImportStatusCreated: "Neu angelegt",
    sdsImportStatusNotFound: "Nicht gefunden",
    sdsImportStatusError: "Fehler",
    sdsImportConfirmSuccess: "Import erfolgreich bestätigt",
    sdsImportConfirmSuccessWithProduct:
      "SDS erfolgreich importiert — {product}",
    sdsImportAnalyzing: "Analysiert...",
    sdsImportStreamError: "Fehler bei der Extraktion",
    sdsImportWarnings: "Warnungen",
    sdsImportPreviewReady: "Vorschau bereit – Felder prüfen und bestätigen",
    sdsImportNoFile: "Keine Datei ausgewählt",
    sdsImportUfiInvalid:
      "Ungültiges Format – erwartet: XXXX-XXXX-XXXX-XXXX (z.B. A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Ungültige CAS-Nummer – erwartet: XXXXXXX-XX-X mit gültiger Prüfziffer",
  },
  en: {
    productComplianceLogo: "AI",
    productComplianceTimeline: "Timeline",
    productComplianceSdsHubTitle: "SDS Compliance Hub",
    productComplianceSdsHubSubtitle:
      "AI-native decisions, traceable and exportable",
    sdsNavOverview: "Overview",
    sdsNavSuppliers: "Suppliers",
    sdsNavProducts: "Products",
    sdsNavActions: "Actions",
    sdsNavComparison: "Comparison",
    sdsNavNewComparison: "New Comparison",
    productComplianceLatency: "Latency 230ms",
    productComplianceAuditStreamingOn: "Audit streaming ON",
    productComplianceTabDashboard: "Role-based dashboard",
    productComplianceTabWorkspaceDiff: "Workspace Smart Diff",
    productComplianceTabTimelineEvidence: "Timeline + Evidence Pack",
    productComplianceTabSitesVariables: "Sites & Variables",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Admin",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "Pending review",
    productComplianceDashboardSummaryPendingDescription:
      "Documents waiting for validation",
    productComplianceDashboardSummaryOverdue: "Overdue tasks",
    productComplianceDashboardSummaryOverdueDescription:
      "Assigned actions outside SLA",
    productComplianceDashboardSummaryReviewTime: "Avg review time",
    productComplianceDashboardSummaryReviewTimeDescription: "Over last 30 days",
    productComplianceDashboardSummaryPrioritization: "Prioritization",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Sections pre-analyzed automatically",
    productComplianceDashboardLibraryTitle: "Materials Library",
    productComplianceDashboardLibrarySubtitle:
      "Search, risk and direct access to AI workspace",
    productComplianceDashboardUploadDrop: "Drop an SDS file here or",
    productComplianceDashboardUploadBrowse: "click to browse",
    productComplianceDashboardSearchPlaceholder: "Search by material or CAS...",
    productComplianceDashboardColumnMaterial: "Material",
    productComplianceDashboardColumnWorkflow: "Workflow",
    productComplianceDashboardColumnRiskScore: "Risk score",
    productComplianceDashboardOpenWorkspace: "Open AI Workspace",
    productComplianceDashboardWorkspaceNotificationTitle: "Workspace",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Open AI Workspace: {name}",
    productComplianceDashboardUploadComment:
      "SDS upload from Product Compliance dashboard",
    productComplianceDashboardUploadSingleFileWarning:
      "Only one file allowed at a time ({fileName}).",
    sdsProductListKpiAwaitingReview: "Awaiting review",
    sdsProductListKpiInProgress: "In progress",
    sdsProductListKpiParsingIncomplete: "Parsing incomplete",
    sdsProductListFilterAll: "All",
    sdsProductListFilterPendingReview: "Pending review",
    sdsProductListFilterInProgress: "In progress",
    sdsProductListFilterApproved: "Approved",
    sdsProductListFilterObsolete: "Obsolete",
    sdsProductListImportSds: "Import SDS",
    sdsProductListReviewSds: "Review SDS",
    sdsProductAddButton: "Add product",
    sdsProductFieldTradeName: "Trade name",
    sdsProductFieldInternalCode: "Internal code",
    sdsProductFieldCas: "CAS number",
    sdsProductFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsProductFieldUfi: "UFI",
    sdsProductFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsProductFieldDescription: "Description",
    sdsProductFieldPrimarySupplier: "Primary supplier",
    sdsFeatureRequiresBackend:
      "This feature requires a backend update and is currently disabled.",
    sdsValidationRequired: "Required",
    sdsProductListColumnProduct: "Product",
    sdsProductListColumnSupplier: "Supplier",
    sdsProductListColumnSdsStatus: "SDS status",
    sdsProductListColumnSections: "Sections",
    sdsProductListColumnLastUpdated: "Last updated",
    sdsOverviewTitle: "Compliance Overview",
    sdsOverviewAwaitingReview: "Awaiting review",
    sdsOverviewAwaitingReviewDesc: "Products waiting for approval",
    sdsOverviewInProgress: "In progress",
    sdsOverviewInProgressDesc: "Active compliance reviews",
    sdsOverviewOverdue: "Overdue",
    sdsOverviewOverdueDesc: "Products with overdue compliance actions",
    sdsOverviewApprovedThisMonth: "Approved this month",
    sdsOverviewApprovedThisMonthDesc: "Products approved in current month",
    sdsOverviewPriorityQueue: "Products Needing Attention",
    sdsOverviewNothingPending: "No pending products.",
    sdsOverviewQuickActions: "Quick Actions",
    sdsOverviewExportActions: "Export actions report",
    sdsOverviewDaysPending: "Days pending",
    sdsOverviewComingSoon: "Coming soon",
    sdsWorkspaceImportNewVersion: "Import New Version",
    sdsWorkspaceViewHistory: "View History",
    sdsWorkspaceCurrentVersion: "Current version",
    sdsWorkspaceSectionsDetected: "Sections detected",
    sdsWorkspaceMissingSections: "Missing sections",
    sdsApprovedSourcesTitle: "Approved Sources",
    sdsApprovedSourcesEmpty: "No approved sources available.",
    sdsWorkspaceCompareTitle: "Compare versions",
    sdsWorkspaceSelectBaseline: "Select baseline",
    sdsWorkspaceSelectIncoming: "Select incoming",
    sdsWorkspaceSelectPlaceholder: "Select version",
    sdsWorkspaceComparingPreview: "Comparing: {baseline} vs. {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Only the most recent version is shown right now. Full version history will be available after a backend update.",
    sdsWorkspaceStartComparison: "Start Comparison",
    sdsWizardBadge: "Wizard",
    sdsWizardStep1Title: "Select Product",
    sdsWizardStep2Title: "Select Versions",
    sdsWizardStep3Title: "Configure",
    sdsWizardSelectedProduct: "Selected product",
    sdsWizardVersionsStubNotice:
      "Only one version is available for this product. Import more versions or wait for the version-history endpoint.",
    sdsWizardCrossSupplier: "Cross-supplier comparison",
    sdsWizardCrossSupplierDesc:
      "When enabled, baseline and incoming can come from different suppliers.",
    sdsWizardNoBaselineOptions: "No baseline versions available.",
    sdsWizardNoIncomingOptions: "No incoming versions available.",
    sdsWizardComparisonName: "Comparison name",
    sdsWizardComparisonNotes: "Comparison notes",
    sdsWizardBack: "Back",
    sdsWizardNext: "Next",
    sdsWizardStartComparison: "Start Comparison",
    sdsComparisonToolbarViewSplit: "Split",
    sdsComparisonToolbarViewUnified: "Unified",
    sdsComparisonToolbarShowChangesOnly: "Show changes only",
    sdsComparisonToolbarJumpSection: "Jump to section",
    sdsComparisonDevelopmentModeNotice:
      "Development mode: showing mock comparison data. Connect /api/product-compliance/comparisons/:id when available.",
    sdsReportExportComparison: "Export SDS comparison report",
    sdsReportBrand: "SMX Product Compliance",
    sdsReportTitle: "SDS comparison report",
    sdsReportGeneratedOn: "Generated on",
    sdsReportProduct: "Product",
    sdsReportBaseline: "Baseline",
    sdsReportIncoming: "Incoming",
    sdsReportBy: "Created by",
    sdsReportDate: "Comparison date",
    sdsReportExecutiveSummary: "Executive summary",
    sdsReportCriticalChanges: "Critical changes",
    sdsReportHighChanges: "High changes",
    sdsReportActionsAssigned: "Assigned actions",
    sdsReportSections: "sections",
    sdsReportSectionAnalysis: "Section analysis",
    sdsReportNoNote: "No compliance note documented.",
    sdsReportUnchangedSections: "Unchanged sections",
    sdsReportReviewedBy: "Reviewed by",
    sdsReportApprovedBy: "Approved by",
    sdsReportSignature: "Signature",
    sdsReportEvidenceVersionsTitle: "All SDS versions",
    sdsReportEvidenceVersionLabel: "Version label",
    sdsReportEvidenceRevisionDate: "Revision date",
    sdsReportEvidenceImportDate: "Import date",
    sdsReportEvidenceWorkflowStatus: "Workflow status",
    sdsReportEvidenceSectionsDetected: "Sections detected",
    sdsReportEvidenceComparisonsTitle: "Comparison history",
    sdsReportEvidenceNoComparisons: "No completed comparisons recorded.",
    sdsReportEvidenceOpenActionsTitle: "Open actions summary",
    sdsReportEvidenceActionCount: "Count",
    sdsReportEvidenceNoOpenActions: "No open actions recorded.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "No content available",
    sdsComparisonUnchangedHidden: "unchanged sections hidden",
    sdsComparisonShowAllSections: "Show all",
    sdsComparisonSectionCriticalChange: "Critical change",
    sdsComparisonSectionHighImpact: "High impact",
    sdsComparisonSectionChanged: "Changed",
    sdsComparisonSectionMinorChange: "Minor change",
    sdsComparisonSectionNoChange: "No change",
    sdsNoteComplianceImpactLabel: "Compliance impact",
    sdsNoteComplianceImpactPlaceholder:
      "Describe the compliance impact for this section.",
    sdsNoteRequiredForCritical:
      "A note is required for critical/high impact changes.",
    sdsNoteChangeSeverityLabel: "Change severity",
    sdsNoteChangeSeverityNone: "None",
    sdsNoteChangeSeverityLow: "Low",
    sdsNoteChangeSeverityMedium: "Medium",
    sdsNoteChangeSeverityHigh: "High",
    sdsNoteChangeSeverityCritical: "Critical",
    sdsNoteAssignedActions: "Assigned actions",
    sdsNoteAddAction: "Add action",
    sdsNoteDepartmentLabel: "Department",
    sdsNoteActionTypeLabel: "Action type",
    sdsNoteActionTypeOther: "Other",
    sdsNoteDueDateLabel: "Due date",
    sdsDeptPlantSafety: "Plant safety",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Procurement",
    sdsDeptQuality: "Quality",
    sdsDeptLogistics: "Logistics",
    sdsDeptWarehouse: "Warehouse",
    sdsActionUpdateSops: "Update SOPs",
    sdsActionUpdateEmergencyProcedures: "Update emergency procedures",
    sdsActionUpdateWorkplaceSignage: "Update workplace signage",
    sdsActionScheduleTraining: "Schedule training",
    sdsActionUpdateRiskAssessment: "Update risk assessment",
    sdsActionReportToAuthority: "Report to authority",
    sdsActionVendorQuery: "Vendor query",
    sdsActionSupplierQualification: "Supplier qualification",
    sdsActionSourceAlternative: "Source alternative supplier",
    sdsActionUpdateSpecification: "Update specification",
    sdsActionUpdateProductDataSheet: "Update product data sheet",
    sdsActionUpdateTransportDoc: "Update transport document",
    sdsActionUpdateHazmatDeclaration: "Update hazmat declaration",
    sdsActionUpdateStorageSop: "Update storage SOP",
    sdsActionReviewSegregation: "Review segregation",
    sdsActionsTitle: "Action Tracker",
    sdsActionsFilterStatus: "Status",
    sdsActionsFilterDepartment: "Department",
    sdsActionsFilterProduct: "Search product or CAS",
    sdsActionsFilterDueDateFrom: "Due date from",
    sdsActionsFilterDueDateTo: "Due date to",
    sdsActionsColumnProduct: "Product",
    sdsActionsColumnSection: "Section",
    sdsActionsColumnDepartment: "Department",
    sdsActionsColumnAction: "Action",
    sdsActionsColumnDueDate: "Due date",
    sdsActionsColumnStatus: "Status",
    sdsActionsMarkComplete: "Mark complete",
    sdsActionsMarkCompleteConfirm:
      "Do you want to mark this action as completed?",
    sdsActionsMarkedComplete: "Action marked as completed",
    sdsActionsStatusOpen: "Open",
    sdsActionsStatusInProgress: "In Progress",
    sdsActionsStatusCompleted: "Completed",
    sdsActionsStatusOverdue: "Overdue",
    sdsActionsSelected: "selected",
    sdsActionsEmptyState:
      "No compliance actions yet. Actions are created while reviewing a comparison.",
    sdsActionsBackendNotice:
      "The action list currently has no backend data. Entries will appear once API integration is available.",
    sdsApproveReviewDecision: "Review decision",
    sdsApproveDocumentationProgress: "Documentation progress",
    sdsApproveBlockedMissingNotes: "Approval blocked, missing notes",
    sdsApproveOpenActions: "Open actions",
    sdsApproveComparisonStarted: "Comparison started",
    sdsApproveBaseline: "Baseline",
    sdsApproveIncoming: "Incoming",
    sdsApproveButton: "Approve",
    sdsRejectButton: "Reject",
    sdsApproveConfirmMessage: "Do you want to approve this comparison?",
    sdsApproveConfirmMessageDetailed:
      'Approve "{incoming}" as the new baseline for "{product}"? The previous baseline ("{baseline}") will be archived as superseded.',
    sdsApproveConfirmTitle: "Approve comparison",
    sdsApproveSuccess: "Comparison approved successfully",
    sdsRejectReasonPrompt: "Please provide a rejection reason",
    sdsRejectTitle: "Reject comparison",
    sdsRejectSuccess: "Comparison rejected",
    productComplianceWorkflowReceived: "Received",
    productComplianceWorkflowInProgress: "In progress",
    productComplianceWorkflowApproved: "Approved",
    productComplianceWorkflowObsolete: "Obsolete",
    productComplianceTimelineSummaryPending: "Pending review",
    productComplianceTimelineSummaryPendingDescription:
      "Versions waiting for release",
    productComplianceTimelineSummaryApproved: "Approved",
    productComplianceTimelineSummaryApprovedDescription:
      "Versions with validated compliance",
    productComplianceTimelineSummarySuperseded: "Superseded",
    productComplianceTimelineSummarySupersededDescription:
      "Versions kept for traceability",
    productComplianceTimelineSectionTitle: "Complete Timeline",
    productComplianceTimelineSectionSubtitle:
      "Chronological SDS versions, status, imports and latest changes",
    productComplianceTimelineFamilySearchPlaceholder:
      "Search by CAS, supplier or product...",
    productComplianceTimelineFamilyProduct: "Product",
    productComplianceTimelineFamilySupplier: "Supplier",
    productComplianceTimelineFamilyVersions: "Versions",
    productComplianceTimelineOrderAz: "A-Z",
    productComplianceTimelineOrderNewest: "Most recent",
    productComplianceTimelineOrderOldest: "Least recent",
    productComplianceTimelineSearchPlaceholder:
      "Search by version, supplier or change...",
    productComplianceTimelineImported: "Import",
    productComplianceTimelineLatestChanges: "Latest changes",
    productComplianceTimelineEmpty:
      "No timeline entries found for current search.",
    productComplianceTimelineShortcutsTitle: "Shortcuts",
    productComplianceTimelineShortcutGenealogy: "Open recursive genealogy",
    productComplianceTimelineShortcutEvidence: "Compose evidence pack",
    productComplianceTimelineShortcutLabel: "Print GHS label",
    productComplianceTimelineLegendTitle: "Status legend",
    productComplianceTimelineCompositionTitle: "Composition",
    productComplianceTimelineCharacteristicsTitle: "Product characteristics",
    productComplianceTimelineDocumentSignalsTitle: "Document signals",
    productComplianceTimelineFieldSupplier: "Supplier",
    productComplianceTimelineFieldUfi: "UFI",
    productComplianceTimelineFieldSubstance: "Substance",
    productComplianceTimelineFieldConcentration: "Concentration",
    productComplianceTimelineFieldSection3Source: "Section 3 source",
    productComplianceTimelineFieldParsingStatus: "Parsing status",
    productComplianceTimelineFieldSectionsDetected: "Sections detected",
    productComplianceTimelineFieldMissingSections: "Missing sections",
    productComplianceTimelineFieldAcceptability: "Acceptability",
    productComplianceTimelineFieldAdditional: "Additional data",
    productComplianceTimelineNotAvailable: "Not available",
    productComplianceTimelineAcceptabilityAccepted: "Accepted",
    productComplianceTimelineAcceptabilityRejected: "Rejected",
    productComplianceTimelineAcceptabilityPending: "Pending",
    productComplianceTimelineSection3SourceHttp: "Extractor API",
    productComplianceTimelineSection3SourceDeterministic:
      "Deterministic analysis",
    productComplianceTimelineSection3SourceHttpDisabled: "Extractor disabled",
    productComplianceTimelineParsingComplete: "Complete",
    productComplianceTimelineParsingIncomplete: "Incomplete",
    productComplianceStatusPendingReview: "Pending review",
    productComplianceStatusApproved: "Approved",
    productComplianceStatusSuperseded: "Superseded",
    productComplianceMaterialSodiumHydroxide: "Sodium Hydroxide 50%",
    productComplianceMaterialSulfuricAcid: "Sulfuric Acid 98%",
    productComplianceSupplierChemcorp: "Supplier: ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Supplier: GlobalChem Ltd.",
    productComplianceTimelineChangeSodium20Section2:
      "Section 2: corrosive pictograms updated",
    productComplianceTimelineChangeSodium20Section16:
      "Section 16: CLP references harmonized",
    productComplianceTimelineChangeSodium21Section8:
      "Section 8: exposure thresholds aligned for Lyon site",
    productComplianceTimelineChangeSodium21Section11:
      "Section 11: toxicology wording clarified",
    productComplianceTimelineChangeSodium30Section8:
      "Section 8: stronger PPE, face shield mandatory",
    productComplianceTimelineChangeSodium30Section2:
      "Section 2: signal word changed from Warning to Danger",
    productComplianceTimelineChangeSodium30Section15:
      "Section 15: regulatory references completed",
    productComplianceTimelineChangeSodium12Section3:
      "Section 3: nominal concentration 49-51%",
    productComplianceTimelineChangeSodium12Section8:
      "Section 8: functional equivalence confirmed",
    productComplianceTimelineChangeSodium12Section16:
      "Section 16: transport addendum added",
    productComplianceTimelineChangeSulfuric15Section8:
      "Section 8: extra hand protection for hot filling",
    productComplianceTimelineChangeSulfuric15Section14:
      "Section 14: UN transport classification refined",
    productComplianceTimelineDeleteVersion: "Delete version",
    productComplianceTimelineDeleteFamily: "Delete family",
    productComplianceTimelineDeleteVersionConfirmTitle: "Delete version",
    productComplianceTimelineDeleteVersionConfirmMessage:
      'Are you sure you want to delete version "{version}"? This action cannot be undone.',
    productComplianceTimelineDeleteFamilyConfirmTitle: "Delete document family",
    productComplianceTimelineDeleteFamilyConfirmMessage:
      "Are you sure you want to delete this document family with all {count} version(s)? This action cannot be undone.",
    productComplianceTimelineDeleteVersionSuccess:
      "Version deleted successfully",
    productComplianceTimelineDeleteFamilySuccess:
      "Document family deleted successfully ({count} version(s))",
    productComplianceTimelineDeleteError: "Error deleting",
    sdsTimelineBackToWorkspace: "Back to Workspace",
    sdsTimelineExportEvidence: "Export Evidence",
    sdsTimelineViewComparison: "View Comparison",
    sdsImportDialogTitle: "Import SDS",
    sdsImportStepValidating: "Validating file...",
    sdsImportStepExtractingText: "Extracting text...",
    sdsImportStepParsingSections: "Parsing sections...",
    sdsImportStepExtractingIdentity: "Extracting identity...",
    sdsImportStepExtractingSubstances: "Extracting substances...",
    sdsImportStepResolvingSupplier: "Resolving supplier...",
    sdsImportStepResolvingProduct: "Resolving product...",
    sdsImportStepComplete: "Extraction complete",
    sdsImportSectionDocument: "Document",
    sdsImportSectionProduct: "Product",
    sdsImportSectionSupplier: "Supplier",
    sdsImportSectionSubstances: "Substances",
    sdsImportSectionComment: "Comment",
    sdsImportFieldFilename: "File",
    sdsImportFieldPages: "Pages",
    sdsImportFieldLanguage: "Language",
    sdsImportFieldRevisionDate: "Revision date",
    sdsImportFieldProductName: "Product name",
    sdsImportFieldTradeName: "Trade name",
    sdsImportFieldUfi: "UFI",
    sdsImportFieldSupplierName: "Supplier name",
    sdsImportSupplierNotFound:
      "Supplier not found in registry. You can link this SDS to an existing supplier or accept a new entry.",
    sdsImportProductNotFound:
      "Product not found in catalog. You can link this SDS to an existing product or accept a new entry.",
    sdsImportLinkExistingSupplier: "Link existing supplier",
    sdsImportLinkExistingProduct: "Link existing product",
    sdsSupplierListTitle: "Suppliers",
    sdsSupplierAddButton: "Add Supplier",
    sdsSupplierEmptyState: "No suppliers available.",
    sdsSupplierBackendNotice:
      "Supplier management requires a backend update — list will appear once available.",
    sdsSupplierContact: "Contact",
    sdsSupplierProductsCount: "Products",
    sdsSupplierSdsDocuments: "SDS Documents",
    sdsSupplierSdsEmptyState: "No SDS documents available.",
    sdsSupplierFieldName: "Name",
    sdsSupplierFieldCode: "Code",
    sdsSupplierFieldCountry: "Country",
    sdsSupplierFieldAddress: "Address",
    sdsSupplierFieldContactName: "Contact name",
    sdsSupplierFieldContactEmail: "Contact email",
    sdsSupplierFieldContact: "Contact",
    sdsSupplierFieldStatus: "Status",
    sdsSupplierFieldNotes: "Notes",
    sdsSupplierCodePlaceholder: "Supplier code",
    sdsSupplierStatusActive: "Active",
    sdsSupplierStatusInactive: "Inactive",
    sdsSupplierStatusUnderReview: "Under review",
    sdsSupplierSavedSuccess: "Supplier saved successfully.",
    sdsSupplierDetailTitle: "Supplier details",
    sdsSupplierNotVerified: "Not verified",
    sdsSupplierFormCrudNotice:
      "Creating and editing suppliers requires a backend update. You can already fill in the form.",
    sdsImportFieldLongComment: "Note",
    sdsImportSubstanceName: "Name",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Concentration",
    sdsImportSubstanceAdd: "Add substance",
    sdsImportButtonConfirm: "Confirm import",
    sdsImportStatusFound: "Found",
    sdsImportStatusCreated: "New",
    sdsImportStatusNotFound: "Not found",
    sdsImportStatusError: "Error",
    sdsImportConfirmSuccess: "Import confirmed successfully",
    sdsImportConfirmSuccessWithProduct: "SDS imported successfully — {product}",
    sdsImportAnalyzing: "Analyzing...",
    sdsImportStreamError: "Error during extraction",
    sdsImportWarnings: "Warnings",
    sdsImportPreviewReady: "Preview ready — review fields and confirm",
    sdsImportNoFile: "No file selected",
    sdsImportUfiInvalid:
      "Invalid format — expected: XXXX-XXXX-XXXX-XXXX (e.g. A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Invalid CAS number — expected: XXXXXXX-XX-X with valid check digit",
  },
  fr: {
    productComplianceLogo: "AI",
    productComplianceTimeline: "Timeline",
    productComplianceSdsHubTitle: "SDS Compliance Hub",
    productComplianceSdsHubSubtitle:
      "Decisions assistees par l'IA, tracables et exportables",
    sdsNavOverview: "Apercu",
    sdsNavSuppliers: "Fournisseurs",
    sdsNavProducts: "Produits",
    sdsNavActions: "Actions",
    sdsNavComparison: "Comparaison",
    sdsNavNewComparison: "Nouvelle comparaison",
    productComplianceLatency: "Latence 230ms",
    productComplianceAuditStreamingOn: "Audit streaming actif",
    productComplianceTabDashboard: "Tableau de bord par rôle",
    productComplianceTabWorkspaceDiff:
      "Diff intelligent de l'espace de travail",
    productComplianceTabTimelineEvidence: "Timeline + dossier de preuves",
    productComplianceTabSitesVariables: "Sites & variables",
    productComplianceRoleHse: "HSE",
    productComplianceRoleQa: "QA",
    productComplianceRoleAdmin: "Admin",
    productComplianceCas: "CAS",
    productComplianceDashboardSummaryPending: "En attente de révision",
    productComplianceDashboardSummaryPendingDescription:
      "Documents en attente de validation",
    productComplianceDashboardSummaryOverdue: "Tâches en retard",
    productComplianceDashboardSummaryOverdueDescription:
      "Actions assignees hors SLA",
    productComplianceDashboardSummaryReviewTime: "Temps moyen de révision",
    productComplianceDashboardSummaryReviewTimeDescription:
      "Sur les 30 derniers jours",
    productComplianceDashboardSummaryPrioritization: "Priorisation",
    productComplianceDashboardSummaryPrioritizationDescription:
      "Sections pre-analysees automatiquement",
    productComplianceDashboardLibraryTitle: "Bibliothèque de matériaux",
    productComplianceDashboardLibrarySubtitle:
      "Recherche, risque et acces direct a l'espace IA",
    productComplianceDashboardUploadDrop: "Déposez un fichier SDS ici ou",
    productComplianceDashboardUploadBrowse: "cliquez pour parcourir",
    productComplianceDashboardSearchPlaceholder:
      "Rechercher par materiau ou CAS...",
    productComplianceDashboardColumnMaterial: "Matériau",
    productComplianceDashboardColumnWorkflow: "Workflow",
    productComplianceDashboardColumnRiskScore: "Score de risque",
    productComplianceDashboardOpenWorkspace: "Ouvrir l'espace IA",
    productComplianceDashboardWorkspaceNotificationTitle: "Espace de travail",
    productComplianceDashboardWorkspaceNotificationMessage:
      "Ouvrir l'espace IA : {name}",
    productComplianceDashboardUploadComment:
      "Televersement SDS depuis le tableau de bord Product Compliance",
    productComplianceDashboardUploadSingleFileWarning:
      "Un seul fichier a la fois est autorise ({fileName}).",
    sdsProductListKpiAwaitingReview: "En attente de revision",
    sdsProductListKpiInProgress: "En cours",
    sdsProductListKpiParsingIncomplete: "Parsing incomplet",
    sdsProductListFilterAll: "Tous",
    sdsProductListFilterPendingReview: "En attente",
    sdsProductListFilterInProgress: "En cours",
    sdsProductListFilterApproved: "Approuve",
    sdsProductListFilterObsolete: "Obsolete",
    sdsProductListImportSds: "Importer SDS",
    sdsProductListReviewSds: "Verifier SDS",
    sdsProductAddButton: "Ajouter un produit",
    sdsProductFieldTradeName: "Nom commercial",
    sdsProductFieldInternalCode: "Code interne",
    sdsProductFieldCas: "Numero CAS",
    sdsProductFieldCasPlaceholder: "XXXXXXX-XX-X",
    sdsProductFieldUfi: "UFI",
    sdsProductFieldUfiPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    sdsProductFieldDescription: "Description",
    sdsProductFieldPrimarySupplier: "Fournisseur principal",
    sdsFeatureRequiresBackend:
      "Cette fonctionnalite necessite une mise a jour backend et est desactivee.",
    sdsValidationRequired: "Champ obligatoire",
    sdsProductListColumnProduct: "Produit",
    sdsProductListColumnSupplier: "Fournisseur",
    sdsProductListColumnSdsStatus: "Statut SDS",
    sdsProductListColumnSections: "Sections",
    sdsProductListColumnLastUpdated: "Derniere mise a jour",
    sdsOverviewTitle: "Apercu conformite",
    sdsOverviewAwaitingReview: "En attente de revision",
    sdsOverviewAwaitingReviewDesc: "Produits en attente de validation",
    sdsOverviewInProgress: "En cours",
    sdsOverviewInProgressDesc: "Revisions de conformite actives",
    sdsOverviewOverdue: "En retard",
    sdsOverviewOverdueDesc: "Produits avec actions de conformite en retard",
    sdsOverviewApprovedThisMonth: "Approuves ce mois",
    sdsOverviewApprovedThisMonthDesc:
      "Produits approuves pendant le mois en cours",
    sdsOverviewPriorityQueue: "Produits necessitant une attention",
    sdsOverviewNothingPending: "Aucun produit en attente.",
    sdsOverviewQuickActions: "Actions rapides",
    sdsOverviewExportActions: "Exporter le rapport d'actions",
    sdsOverviewDaysPending: "Jours en attente",
    sdsOverviewComingSoon: "Bientot disponible",
    sdsWorkspaceImportNewVersion: "Importer une nouvelle version",
    sdsWorkspaceViewHistory: "Voir l'historique",
    sdsWorkspaceCurrentVersion: "Version actuelle",
    sdsWorkspaceSectionsDetected: "Sections detectees",
    sdsWorkspaceMissingSections: "Sections manquantes",
    sdsApprovedSourcesTitle: "Sources approuvees",
    sdsApprovedSourcesEmpty: "Aucune source approuvee disponible.",
    sdsWorkspaceCompareTitle: "Comparer les versions",
    sdsWorkspaceSelectBaseline: "Selectionner la baseline",
    sdsWorkspaceSelectIncoming: "Selectionner l'entrante",
    sdsWorkspaceSelectPlaceholder: "Selectionner une version",
    sdsWorkspaceComparingPreview: "Comparaison : {baseline} vs {incoming}",
    sdsWorkspaceVersionsStubNotice:
      "Seule la version la plus recente est affichee actuellement. L'historique complet sera disponible apres une mise a jour backend.",
    sdsWorkspaceStartComparison: "Demarrer la comparaison",
    sdsWizardBadge: "Assistant",
    sdsWizardStep1Title: "Selectionner un produit",
    sdsWizardStep2Title: "Selectionner les versions",
    sdsWizardStep3Title: "Configurer",
    sdsWizardSelectedProduct: "Produit selectionne",
    sdsWizardVersionsStubNotice:
      "Une seule version est disponible pour ce produit. Importez d'autres versions ou attendez le point d'acces de l'historique des versions.",
    sdsWizardCrossSupplier: "Comparaison inter-fournisseurs",
    sdsWizardCrossSupplierDesc:
      "Si active, la baseline et l'entrante peuvent provenir de fournisseurs differents.",
    sdsWizardNoBaselineOptions: "Aucune version baseline disponible.",
    sdsWizardNoIncomingOptions: "Aucune version entrante disponible.",
    sdsWizardComparisonName: "Nom de la comparaison",
    sdsWizardComparisonNotes: "Notes de comparaison",
    sdsWizardBack: "Retour",
    sdsWizardNext: "Suivant",
    sdsWizardStartComparison: "Demarrer la comparaison",
    sdsComparisonToolbarViewSplit: "Split",
    sdsComparisonToolbarViewUnified: "Unifie",
    sdsComparisonToolbarShowChangesOnly: "Afficher uniquement les changements",
    sdsComparisonToolbarJumpSection: "Aller a la section",
    sdsComparisonDevelopmentModeNotice:
      "Mode developpement : affichage de donnees de comparaison mock. Connectez /api/product-compliance/comparisons/:id lorsqu'il sera disponible.",
    sdsReportExportComparison: "Exporter le rapport de comparaison SDS",
    sdsReportBrand: "SMX Product Compliance",
    sdsReportTitle: "Rapport de comparaison SDS",
    sdsReportGeneratedOn: "Genere le",
    sdsReportProduct: "Produit",
    sdsReportBaseline: "Baseline",
    sdsReportIncoming: "Entrante",
    sdsReportBy: "Cree par",
    sdsReportDate: "Date de comparaison",
    sdsReportExecutiveSummary: "Resume executif",
    sdsReportCriticalChanges: "Changements critiques",
    sdsReportHighChanges: "Changements eleves",
    sdsReportActionsAssigned: "Actions assignees",
    sdsReportSections: "sections",
    sdsReportSectionAnalysis: "Analyse par section",
    sdsReportNoNote: "Aucune note de conformite documentee.",
    sdsReportUnchangedSections: "Sections inchangees",
    sdsReportReviewedBy: "Relu par",
    sdsReportApprovedBy: "Approuve par",
    sdsReportSignature: "Signature",
    sdsReportEvidenceVersionsTitle: "Toutes les versions SDS",
    sdsReportEvidenceVersionLabel: "Libelle de version",
    sdsReportEvidenceRevisionDate: "Date de revision",
    sdsReportEvidenceImportDate: "Date d'import",
    sdsReportEvidenceWorkflowStatus: "Statut du workflow",
    sdsReportEvidenceSectionsDetected: "Sections detectees",
    sdsReportEvidenceComparisonsTitle: "Historique des comparaisons",
    sdsReportEvidenceNoComparisons: "Aucune comparaison finalisee enregistree.",
    sdsReportEvidenceOpenActionsTitle: "Resume des actions ouvertes",
    sdsReportEvidenceActionCount: "Nombre",
    sdsReportEvidenceNoOpenActions: "Aucune action ouverte enregistree.",
    productComplianceUfi: "UFI",
    sdsComparisonSectionEmpty: "Aucun contenu disponible",
    sdsComparisonUnchangedHidden: "sections inchangees masquees",
    sdsComparisonShowAllSections: "Tout afficher",
    sdsComparisonSectionCriticalChange: "Changement critique",
    sdsComparisonSectionHighImpact: "Impact eleve",
    sdsComparisonSectionChanged: "Change",
    sdsComparisonSectionMinorChange: "Changement mineur",
    sdsComparisonSectionNoChange: "Aucun changement",
    sdsNoteComplianceImpactLabel: "Impact conformite",
    sdsNoteComplianceImpactPlaceholder:
      "Decrivez l'impact conformite pour cette section.",
    sdsNoteRequiredForCritical:
      "Une note est obligatoire pour les changements critiques/importants.",
    sdsNoteChangeSeverityLabel: "Severite du changement",
    sdsNoteChangeSeverityNone: "Aucune",
    sdsNoteChangeSeverityLow: "Faible",
    sdsNoteChangeSeverityMedium: "Moyenne",
    sdsNoteChangeSeverityHigh: "Elevee",
    sdsNoteChangeSeverityCritical: "Critique",
    sdsNoteAssignedActions: "Actions assignees",
    sdsNoteAddAction: "Ajouter une action",
    sdsNoteDepartmentLabel: "Departement",
    sdsNoteActionTypeLabel: "Type d'action",
    sdsNoteActionTypeOther: "Autre",
    sdsNoteDueDateLabel: "Date d'echeance",
    sdsDeptPlantSafety: "Securite usine",
    sdsDeptEhs: "EHS",
    sdsDeptProcurement: "Achats",
    sdsDeptQuality: "Qualite",
    sdsDeptLogistics: "Logistique",
    sdsDeptWarehouse: "Entrepot",
    sdsActionUpdateSops: "Mettre a jour les SOP",
    sdsActionUpdateEmergencyProcedures:
      "Mettre a jour les procedures d'urgence",
    sdsActionUpdateWorkplaceSignage: "Mettre a jour la signalisation de poste",
    sdsActionScheduleTraining: "Planifier une formation",
    sdsActionUpdateRiskAssessment: "Mettre a jour l'evaluation des risques",
    sdsActionReportToAuthority: "Notifier l'autorite",
    sdsActionVendorQuery: "Question au fournisseur",
    sdsActionSupplierQualification: "Qualification fournisseur",
    sdsActionSourceAlternative: "Sourcer une alternative",
    sdsActionUpdateSpecification: "Mettre a jour la specification",
    sdsActionUpdateProductDataSheet: "Mettre a jour la fiche produit",
    sdsActionUpdateTransportDoc: "Mettre a jour le document transport",
    sdsActionUpdateHazmatDeclaration:
      "Mettre a jour la declaration matieres dangereuses",
    sdsActionUpdateStorageSop: "Mettre a jour la SOP de stockage",
    sdsActionReviewSegregation: "Revoir la segregation",
    sdsActionsTitle: "Suivi des actions",
    sdsActionsFilterStatus: "Statut",
    sdsActionsFilterDepartment: "Departement",
    sdsActionsFilterProduct: "Rechercher produit ou CAS",
    sdsActionsFilterDueDateFrom: "Echeance de",
    sdsActionsFilterDueDateTo: "Echeance a",
    sdsActionsColumnProduct: "Produit",
    sdsActionsColumnSection: "Section",
    sdsActionsColumnDepartment: "Departement",
    sdsActionsColumnAction: "Action",
    sdsActionsColumnDueDate: "Echeance",
    sdsActionsColumnStatus: "Statut",
    sdsActionsMarkComplete: "Marquer comme termine",
    sdsActionsMarkCompleteConfirm:
      "Voulez-vous marquer cette action comme terminee ?",
    sdsActionsMarkedComplete: "Action marquee comme terminee",
    sdsActionsStatusOpen: "Ouverte",
    sdsActionsStatusInProgress: "En cours",
    sdsActionsStatusCompleted: "Terminee",
    sdsActionsStatusOverdue: "En retard",
    sdsActionsSelected: "selectionnees",
    sdsActionsEmptyState:
      "Aucune action de conformite pour l'instant. Les actions sont creees lors de la revue d'une comparaison.",
    sdsActionsBackendNotice:
      "La liste d'actions ne contient actuellement aucune donnee backend. Les entrees apparaitront une fois l'integration API disponible.",
    sdsApproveReviewDecision: "Revue et decision",
    sdsApproveDocumentationProgress: "Progression de la documentation",
    sdsApproveBlockedMissingNotes: "Validation bloquee, notes manquantes",
    sdsApproveOpenActions: "Actions ouvertes",
    sdsApproveComparisonStarted: "Comparaison demarree",
    sdsApproveBaseline: "Baseline",
    sdsApproveIncoming: "Entrante",
    sdsApproveButton: "Approuver",
    sdsRejectButton: "Rejeter",
    sdsApproveConfirmMessage: "Voulez-vous approuver cette comparaison ?",
    sdsApproveConfirmMessageDetailed:
      'Approuver "{incoming}" comme nouvelle baseline pour "{product}" ? La baseline precedente ("{baseline}") sera archivee comme remplacee.',
    sdsApproveConfirmTitle: "Approuver la comparaison",
    sdsApproveSuccess: "Comparaison approuvee avec succes",
    sdsRejectReasonPrompt: "Veuillez saisir un motif de rejet",
    sdsRejectTitle: "Rejeter la comparaison",
    sdsRejectSuccess: "Comparaison rejetee",
    productComplianceWorkflowReceived: "Recu",
    productComplianceWorkflowInProgress: "En cours",
    productComplianceWorkflowApproved: "Approuvé",
    productComplianceWorkflowObsolete: "Obsolète",
    productComplianceTimelineSummaryPending: "En attente de revision",
    productComplianceTimelineSummaryPendingDescription:
      "Versions en attente de publication",
    productComplianceTimelineSummaryApproved: "Approuve",
    productComplianceTimelineSummaryApprovedDescription:
      "Versions avec conformite validee",
    productComplianceTimelineSummarySuperseded: "Remplace",
    productComplianceTimelineSummarySupersededDescription:
      "Versions conservees pour la tracabilite",
    productComplianceTimelineSectionTitle: "Timeline complete",
    productComplianceTimelineSectionSubtitle:
      "Versions SDS chronologiques, statut, imports et dernieres modifications",
    productComplianceTimelineFamilySearchPlaceholder:
      "Rechercher par CAS, fournisseur ou produit...",
    productComplianceTimelineFamilyProduct: "Produit",
    productComplianceTimelineFamilySupplier: "Fournisseur",
    productComplianceTimelineFamilyVersions: "Versions",
    productComplianceTimelineOrderAz: "A-Z",
    productComplianceTimelineOrderNewest: "Plus recent",
    productComplianceTimelineOrderOldest: "Plus ancien",
    productComplianceTimelineSearchPlaceholder:
      "Rechercher par version, fournisseur ou changement...",
    productComplianceTimelineImported: "Import",
    productComplianceTimelineLatestChanges: "Dernieres modifications",
    productComplianceTimelineEmpty:
      "Aucune entree de timeline trouvee pour la recherche en cours.",
    productComplianceTimelineShortcutsTitle: "Raccourcis",
    productComplianceTimelineShortcutGenealogy:
      "Ouvrir la genealogie recursive",
    productComplianceTimelineShortcutEvidence: "Composer le dossier de preuves",
    productComplianceTimelineShortcutLabel: "Imprimer l'etiquette GHS",
    productComplianceTimelineLegendTitle: "Legende des statuts",
    productComplianceTimelineCompositionTitle: "Composition",
    productComplianceTimelineCharacteristicsTitle: "Caracteristiques produit",
    productComplianceTimelineDocumentSignalsTitle: "Signaux documentaires",
    productComplianceTimelineFieldSupplier: "Fournisseur",
    productComplianceTimelineFieldUfi: "UFI",
    productComplianceTimelineFieldSubstance: "Substance",
    productComplianceTimelineFieldConcentration: "Concentration",
    productComplianceTimelineFieldSection3Source: "Source section 3",
    productComplianceTimelineFieldParsingStatus: "Statut du parsing",
    productComplianceTimelineFieldSectionsDetected: "Sections detectees",
    productComplianceTimelineFieldMissingSections: "Sections manquantes",
    productComplianceTimelineFieldAcceptability: "Acceptabilite",
    productComplianceTimelineFieldAdditional: "Informations complementaires",
    productComplianceTimelineNotAvailable: "Non disponible",
    productComplianceTimelineAcceptabilityAccepted: "Accepte",
    productComplianceTimelineAcceptabilityRejected: "Rejete",
    productComplianceTimelineAcceptabilityPending: "En attente",
    productComplianceTimelineSection3SourceHttp: "API extracteur",
    productComplianceTimelineSection3SourceDeterministic:
      "Analyse deterministe",
    productComplianceTimelineSection3SourceHttpDisabled: "Extracteur desactive",
    productComplianceTimelineParsingComplete: "Complet",
    productComplianceTimelineParsingIncomplete: "Incomplet",
    productComplianceStatusPendingReview: "En attente de revision",
    productComplianceStatusApproved: "Approuve",
    productComplianceStatusSuperseded: "Remplace",
    productComplianceMaterialSodiumHydroxide: "Hydroxyde de sodium 50%",
    productComplianceMaterialSulfuricAcid: "Acide sulfurique 98%",
    productComplianceSupplierChemcorp: "Fournisseur : ChemCorp Inc.",
    productComplianceSupplierGlobalchem: "Fournisseur : GlobalChem Ltd.",
    productComplianceTimelineChangeSodium20Section2:
      "Section 2 : pictogrammes corrosifs mis a jour",
    productComplianceTimelineChangeSodium20Section16:
      "Section 16 : references CLP harmonisees",
    productComplianceTimelineChangeSodium21Section8:
      "Section 8 : seuils d'exposition alignes pour le site de Lyon",
    productComplianceTimelineChangeSodium21Section11:
      "Section 11 : formulation toxicologique clarifiee",
    productComplianceTimelineChangeSodium30Section8:
      "Section 8 : EPI renforces, visiere obligatoire",
    productComplianceTimelineChangeSodium30Section2:
      "Section 2 : mention d'avertissement modifiee de Warning a Danger",
    productComplianceTimelineChangeSodium30Section15:
      "Section 15 : references reglementaires completees",
    productComplianceTimelineChangeSodium12Section3:
      "Section 3 : concentration nominale 49-51%",
    productComplianceTimelineChangeSodium12Section8:
      "Section 8 : equivalence fonctionnelle confirmee",
    productComplianceTimelineChangeSodium12Section16:
      "Section 16 : addendum transport ajoute",
    productComplianceTimelineChangeSulfuric15Section8:
      "Section 8 : protection supplementaire des mains pour le remplissage a chaud",
    productComplianceTimelineChangeSulfuric15Section14:
      "Section 14 : classification de transport ONU affinee",
    productComplianceTimelineDeleteVersion: "Supprimer la version",
    productComplianceTimelineDeleteFamily: "Supprimer la famille",
    productComplianceTimelineDeleteVersionConfirmTitle: "Supprimer la version",
    productComplianceTimelineDeleteVersionConfirmMessage:
      'Etes-vous sur de vouloir supprimer la version "{version}" ? Cette action est irreversible.',
    productComplianceTimelineDeleteFamilyConfirmTitle:
      "Supprimer la famille de documents",
    productComplianceTimelineDeleteFamilyConfirmMessage:
      "Etes-vous sur de vouloir supprimer cette famille de documents avec ses {count} version(s) ? Cette action est irreversible.",
    productComplianceTimelineDeleteVersionSuccess:
      "Version supprimee avec succes",
    productComplianceTimelineDeleteFamilySuccess:
      "Famille de documents supprimee avec succes ({count} version(s))",
    productComplianceTimelineDeleteError: "Erreur lors de la suppression",
    sdsTimelineBackToWorkspace: "Retour a l'espace de travail",
    sdsTimelineExportEvidence: "Exporter les preuves",
    sdsTimelineViewComparison: "Voir la comparaison",
    sdsImportDialogTitle: "Importer SDS",
    sdsImportStepValidating: "Validation du fichier...",
    sdsImportStepExtractingText: "Extraction du texte...",
    sdsImportStepParsingSections: "Analyse des sections...",
    sdsImportStepExtractingIdentity: "Extraction de l'identité...",
    sdsImportStepExtractingSubstances: "Extraction des substances...",
    sdsImportStepResolvingSupplier: "Recherche du fournisseur...",
    sdsImportStepResolvingProduct: "Recherche du produit...",
    sdsImportStepComplete: "Extraction terminée",
    sdsImportSectionDocument: "Document",
    sdsImportSectionProduct: "Produit",
    sdsImportSectionSupplier: "Fournisseur",
    sdsImportSectionSubstances: "Substances",
    sdsImportSectionComment: "Commentaire",
    sdsImportFieldFilename: "Fichier",
    sdsImportFieldPages: "Pages",
    sdsImportFieldLanguage: "Langue",
    sdsImportFieldRevisionDate: "Date de révision",
    sdsImportFieldProductName: "Nom du produit",
    sdsImportFieldTradeName: "Nom commercial",
    sdsImportFieldUfi: "UFI",
    sdsImportFieldSupplierName: "Nom du fournisseur",
    sdsImportSupplierNotFound:
      "Fournisseur introuvable dans le registre. Vous pouvez lier ce SDS à un fournisseur existant ou accepter une nouvelle entrée.",
    sdsImportProductNotFound:
      "Produit introuvable dans le catalogue. Vous pouvez lier ce SDS à un produit existant ou accepter une nouvelle entrée.",
    sdsImportLinkExistingSupplier: "Lier un fournisseur existant",
    sdsImportLinkExistingProduct: "Lier un produit existant",
    sdsSupplierListTitle: "Fournisseurs",
    sdsSupplierAddButton: "Ajouter un fournisseur",
    sdsSupplierEmptyState: "Aucun fournisseur disponible.",
    sdsSupplierBackendNotice:
      "La gestion des fournisseurs necessite une mise a jour backend — la liste apparaitra des qu'elle sera disponible.",
    sdsSupplierContact: "Contact",
    sdsSupplierProductsCount: "Produits",
    sdsSupplierSdsDocuments: "Documents SDS",
    sdsSupplierSdsEmptyState: "Aucun document SDS disponible.",
    sdsSupplierFieldName: "Nom",
    sdsSupplierFieldCode: "Code",
    sdsSupplierFieldCountry: "Pays",
    sdsSupplierFieldAddress: "Adresse",
    sdsSupplierFieldContactName: "Nom du contact",
    sdsSupplierFieldContactEmail: "Email du contact",
    sdsSupplierFieldContact: "Contact",
    sdsSupplierFieldStatus: "Statut",
    sdsSupplierFieldNotes: "Notes",
    sdsSupplierCodePlaceholder: "Code fournisseur",
    sdsSupplierStatusActive: "Actif",
    sdsSupplierStatusInactive: "Inactif",
    sdsSupplierStatusUnderReview: "En revision",
    sdsSupplierSavedSuccess: "Fournisseur enregistre avec succes.",
    sdsSupplierDetailTitle: "Details du fournisseur",
    sdsSupplierNotVerified: "Non vérifié",
    sdsSupplierFormCrudNotice:
      "La création et la modification de fournisseurs nécessitent une mise à jour du backend. Vous pouvez déjà remplir le formulaire.",
    sdsImportFieldLongComment: "Note",
    sdsImportSubstanceName: "Nom",
    sdsImportSubstanceCas: "CAS",
    sdsImportSubstanceConcentration: "Concentration",
    sdsImportSubstanceAdd: "Ajouter une substance",
    sdsImportButtonConfirm: "Confirmer l'import",
    sdsImportStatusFound: "Trouvé",
    sdsImportStatusCreated: "Nouveau",
    sdsImportStatusNotFound: "Non trouvé",
    sdsImportStatusError: "Erreur",
    sdsImportConfirmSuccess: "Import confirmé avec succès",
    sdsImportConfirmSuccessWithProduct: "SDS importé avec succès — {product}",
    sdsImportAnalyzing: "Analyse en cours...",
    sdsImportStreamError: "Erreur lors de l'extraction",
    sdsImportWarnings: "Avertissements",
    sdsImportPreviewReady: "Aperçu prêt — vérifiez les champs et confirmez",
    sdsImportNoFile: "Aucun fichier sélectionné",
    sdsImportUfiInvalid:
      "Format invalide — attendu : XXXX-XXXX-XXXX-XXXX (ex. A1B2-C3D4-E5F6-G7H8)",
    sdsImportCasInvalid:
      "Numéro CAS invalide — attendu : XXXXXXX-XX-X avec chiffre de contrôle valide",
  },
};
